import { createApiClient } from "@pustak-lms/api-client";

interface ConsoleLocation { protocol: string; hostname: string; port?: string }
export function resolveApiBaseUrl(
  location: ConsoleLocation = window.location,
  configured = import.meta.env.VITE_API_BASE_URL
): string {
  if (configured?.trim()) {
    const url = new URL(configured);
    const origin = `${location.protocol}//${location.hostname}${location.port ? `:${location.port}` : ""}`;
    if (!["http:", "https:"].includes(url.protocol) || url.origin !== origin) {
      throw new Error("Platform API must use the current origin for host-only authentication");
    }
  }
  return "";
}
export function platformApiClient() {
  return createApiClient({ baseUrl: resolveApiBaseUrl() });
}
